import { useTranslation } from 'react-i18next'
import { Controller } from 'react-hook-form'
import { H3, Input, Span, Text, Textarea } from '@/components/atoms'
import { DatePickerField, SelectField } from '@/components/molecules'
import { useClaimsPetStepOne } from './page.claims.pet-step-one.hook'
import { FORM_PLACEHOLDER } from '@/shared/constants/forms'

export function ClaimsPetStepOnePage() {
  const { t } = useTranslation()
  const {
    control,
    rules,
    fieldErrors,
    petOptions,
    toAmountCents,
    formatAmountCents,
    invoiceMaxDate,
    descriptionMaxLength,
  } = useClaimsPetStepOne()

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4 md:hidden">
        <H3 className="text-[2rem]! text-neutral-900">
          <Span textSize="">{t('claims.pet.titleStart')}</Span>
          <br />
          <Span textSize="" className="text-indigo-base!">
            {t('claims.pet.titleHighlight')}
          </Span>
        </H3>
        <Text className="text-neutral-900">{t('claims.pet.description')}</Text>
      </div>

      <H3 className="text-[1.5rem] text-neutral-900">
        {t('claims.pet.stepOne.title')}
      </H3>

      <Controller
        control={control}
        name="petId"
        rules={rules.petId}
        render={({ field }) => (
          <SelectField
            id="petId"
            label={t('claims.pet.form.petLabel')}
            placeholder={t('claims.pet.form.petPlaceholder')}
            options={petOptions}
            value={field.value}
            error={fieldErrors.petId}
            onSelect={field.onChange}
            onBlur={field.onBlur}
          />
        )}
      />

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <Controller
          control={control}
          name="invoiceDate"
          rules={rules.invoiceDate}
          render={({ field }) => (
            <DatePickerField
              id="invoiceDate"
              label={t('claims.pet.form.invoiceDateLabel')}
              placeholder={FORM_PLACEHOLDER.DATE}
              value={field.value}
              maxDate={invoiceMaxDate}
              error={fieldErrors.invoiceDate}
              onChange={field.onChange}
              onBlur={field.onBlur}
              dropdownMonthYear
              panelPosition="relative"
            />
          )}
        />
        <Controller
          control={control}
          name="amount"
          rules={rules.amount}
          render={({ field }) => (
            <Input
              id="amount"
              data-testid="pet-claim-amount-input"
              label={t('claims.pet.form.amountLabel')}
              placeholder={FORM_PLACEHOLDER.AMOUNT}
              inputMode="numeric"
              value={formatAmountCents(field.value)}
              error={fieldErrors.amount}
              onChange={(e) => field.onChange(toAmountCents(e.target.value))}
              onBlur={field.onBlur}
            />
          )}
        />
      </div>

      <Controller
        control={control}
        name="description"
        rules={rules.description}
        render={({ field }) => (
          <Textarea
            id="description"
            data-testid="pet-claim-description-input"
            label={t('claims.pet.form.descriptionLabel')}
            maxLength={descriptionMaxLength}
            placeholder={t('claims.pet.form.descriptionPlaceholder')}
            value={field.value}
            error={fieldErrors.description}
            onChange={field.onChange}
            onBlur={field.onBlur}
          />
        )}
      />
    </div>
  )
}
